/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, total: NonNullable<unknown> }} Processing_Job_OfInputs */

const en_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processing job ${i?.completed} of ${i?.total}`)
};

const fr_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Traitement de la tâche ${i?.completed} sur ${i?.total}`)
};

const de_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verarbeitungsauftrag ${i?.completed} von ${i?.total}`)
};

const it_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elaborazione del lavoro ${i?.completed} di ${i?.total}`)
};

const ru_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обработка задания ${i?.completed} из ${i?.total}`)
};

const es_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Procesando el trabajo ${i?.completed} de ${i?.total}`)
};

const zh_cn2_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`正在处理 ${i?.total} 的 ${i?.completed} 作业`)
};

const ja_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ジョブ ${i?.completed} / ${i?.total} を処理中`)
};

const hi_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} के ${i?.completed} कार्य की प्रक्रिया चल रही है`)
};

const pt_pt2_processing_job_of = /** @type {(inputs: Processing_Job_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Processando tarefa ${i?.completed} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Processing job {completed} of {total}" |
*
* @param {Processing_Job_OfInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const processing_job_of = /** @type {((inputs: Processing_Job_OfInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Processing_Job_OfInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_processing_job_of(inputs)
	if (locale === "de") return de_processing_job_of(inputs)
	if (locale === "it") return it_processing_job_of(inputs)
	if (locale === "ru") return ru_processing_job_of(inputs)
	if (locale === "es") return es_processing_job_of(inputs)
	if (locale === "zh-CN") return zh_cn2_processing_job_of(inputs)
	if (locale === "ja") return ja_processing_job_of(inputs)
	if (locale === "hi") return hi_processing_job_of(inputs)
	if (locale === "pt-PT") return pt_pt2_processing_job_of(inputs)
	return en_processing_job_of(inputs)
});